import $ from 'jquery'
import Swiper from '@/swiper-bundle'
import { Controller } from 'swiper/modules'
import 'swiper/less/controller'
import { Navigation } from 'swiper/modules'
import 'swiper/less/navigation'

/**
 * Initializes the Swiper component for product view thumbnails.
 *
 * These are displayed under the hero on non-mobile viewports.
 */
export const initializeSwiperProdViews = () => {
  const $prodViewSlides = $('#prod-views .swiper-slide')
  if ($prodViewSlides.length) {
    $prodViewSlides.on(
      'click',
      (
        e // Don't jump to top (don't navigate to #)
      ) => e.preventDefault()
    )

    return new Swiper('#prod-views.swiper', {
      modules: [Navigation, Controller],
      centeredSlides: true,
      slidesPerView: 'auto',
      slideToClickedSlide: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      }
    })
  } else {
    return null
  }
}
